
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_48801","data-name":"Group 48801","transform":"translate(5534 6106)"}},[_c('path',{attrs:{"id":"Path_37978","data-name":"Path 37978","d":"M21 12a9 9 0 11-9-9 9 9 0 019 9z","transform":"translate(-5537 -6109)","fill":"#e0e0fe"}}),_c('path',{attrs:{"id":"Path_37977","data-name":"Path 37977","d":"M-5522-6097.75l-3-3m0 0l-3 3m3-3v7.5","fill":"#2e0661","stroke":"#8787e2","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])
          )
        }
      }
    